import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-walkthrough',
  templateUrl: './walkthrough.component.html',
  styleUrls: ['./walkthrough.component.scss']
})
export class WalkthroughComponent implements OnInit {
  @Input() swiperContent = null;

  
  constructor() { }

  ngOnInit() {
  }

}
